import { render, staticRenderFns } from "./InfoLabel.vue?vue&type=template&id=3e3d98a4&scoped=true&"
import script from "./InfoLabel.vue?vue&type=script&lang=js&"
export * from "./InfoLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3d98a4",
  null
  
)

export default component.exports